// File: frontend/src/services/seoAnalyticsService.js
// Version: 1.1
// Date: 2026-04-28
// Description: API service for SEO Analytics Dashboard endpoints (SerpAPI + Ahrefs).
// History:
// - [v1.1]: Added Ahrefs methods (overview/trends/citations/alerts/triggerSnapshot) for Phase 07-03 frontend.
// - [v1.0]: Initial SerpAPI methods (domains, positions, trends, competitors).

import apiService from './apiService';

const seoAnalyticsService = {
  // ---------------------------------------------------------------------------
  // SerpAPI-backed endpoints (Phase 07-01)
  // ---------------------------------------------------------------------------
  async getDomains() {
    return apiService.makeRequest('/seo-analytics/domains');
  },
  async getPositions(domainId) {
    return apiService.makeRequest(`/seo-analytics/domains/${domainId}/positions`);
  },
  async getTrends(domainId, days = 30) {
    return apiService.makeRequest(`/seo-analytics/domains/${domainId}/trends?days=${days}`);
  },
  async getCompetitors(domainId) {
    return apiService.makeRequest(`/seo-analytics/domains/${domainId}/competitors`);
  },

  // ---------------------------------------------------------------------------
  // Ahrefs-backed endpoints (Phase 07-03)
  // ---------------------------------------------------------------------------
  async getAhrefsOverview(domainId) {
    return apiService.makeRequest(`/seo-analytics/ahrefs/domains/${domainId}/overview`);
  },
  async getAhrefsTrends(domainId, days = 30) {
    return apiService.makeRequest(
      `/seo-analytics/ahrefs/domains/${domainId}/trends?days=${days}`
    );
  },
  async getAhrefsCitations(domainId) {
    return apiService.makeRequest(`/seo-analytics/ahrefs/domains/${domainId}/ai-citations`);
  },
  async getAhrefsAlerts(domainId) {
    return apiService.makeRequest(`/seo-analytics/ahrefs/domains/${domainId}/alerts`);
  },
  async triggerAhrefsSnapshot(domainId) {
    // Creator-only — backend enforces RBAC, frontend should also gate the button
    return apiService.makeRequest(
      `/seo-analytics/ahrefs/domains/${domainId}/snapshot`,
      { method: 'POST' }
    );
  },
};

export default seoAnalyticsService;
